export default "__VITE_ASSET__16bc0518__"